export var initialConfig = {
    hasFetchedConfig: false,
    config: {
        header: {
            logo: {
                image: "https://acm-assets.eco.astro.com.my/images/astro-logo-white.svg",
                name: "Astro",
                url: "",
            },
            divisions: [
                { name: "Consumer", url: "" },
                { name: "Business", url: "" },
                { name: "Corporate", url: "" },
            ],
            navItems: [
                { name: "Products & Services" },
                { name: "TV Guide" },
                { name: "Promotions" },
                { name: "My Account" },
                { name: "Support" },
            ],
            search: {
                endpoint: "",
                navItem: "Search",
                placeholder: "",
            },
            sso: {
                navItem: "Login",
                navItemAuthenticated: "Profile",
                manageProfile: "",
                logout: "",
            },
            bcp: {
                icon: "",
                iconAlt: "",
                backgroundColor: "",
                textColor: "",
                linkColor: "",
                closeButtonColor: "",
                cookie: {
                    duration: 0,
                },
            },
            ourBrands: { name: "Our Brands" },
            uxf: {
                logoutUrl: "",
                whitelistedAddress: [],
            },
            ulm: {
                urlParams: {
                    domain: "",
                    pathname: "",
                    params: {},
                },
                client: "",
                sessionApi: {
                    refresh: "",
                    getUser: "",
                },
                expiry: {
                    refreshSession: 0,
                    startSession: 0,
                },
            },
        },
        footer: {
            columns: [],
            complaint: {
                image: "",
                name: "",
                url: "",
            },
            contactUsHtml: "",
            socialIcons: [],
            footerLinks: [],
            copyrightHtml: "",
        },
        liveChat: {
            needHelp: "",
            bubbleTitle: "",
            bubbleDesc: "",
            scrollLengthToAppearBubbleInPixels: 400,
            idleTimeToShowBubble: 10,
            whatsAppLink: "",
            whatsAppImage: "",
            defaultShortCode: "",
            urlsToEnableLiveChat: [],
        },
        entryModal: {
            closeIconColor: "",
            image: {
                name: "",
                url: "",
                mobileImg: {
                    image: "",
                    width: 0,
                    height: 0,
                },
                desktopImg: {
                    image: "",
                    width: 0,
                    height: 0,
                },
            },
            applicablePortals: [],
            cookieDuration: 0,
            userSegment: 0,
        },
    },
    endpoints: {
        df: {
            prod: "https://digital-fortress-assets.eco.astro.com.my/prod/config/XdovZqB9Rg/config.json",
            stg: "https://digital-fortress-dev.eco.astro.com.my/dev/config/N8evxoJBVL/config.json",
            dev: "https://digital-fortress-dev.eco.astro.com.my/dev/config/6rPy3LqBn0/config.json",
        },
        bcp: {
            prod: "https://contenthub-api.eco.astro.com.my/bcp/messages.json",
            stg: "https://contenthub-api-stg.eco.astro.com.my/bcp/messages.json",
            dev: "https://contenthub-api-stg.eco.astro.com.my/bcp/messages.json",
        },
        crossPromo: "https://digital-fortress-assets.eco.astro.com.my/prod/config/6rPy3LBn0W/config.json",
    },
    environment: null,
};
